import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const COMPLETED = 1;
const IN_PROGRESS = 0;

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const varianceTypes = [
    { id: 1, name: 'Stock Sold' },
    { id: 2, name: 'Stock Wastage' },
    { id: 3, name: 'Stock Damage' },
    { id: 4, name: 'Stock Stolen / Loss' },
    { id: 5, name: 'Incorrect Counting' },
    { id: 6, name: 'Overtopping' },
];

const state = {
    stockCheck: {
        id: null,
        status: 0,
        description: null,
        reference_id: null,
        outlet: {
            id: null,
            name: null,
        },
        stocks: [],
    },
};

const getters = {
    stockCheck(state) {
        return state.stockCheck;
    },

    hasFinalized(state) {
        return state.stockCheck.status == COMPLETED;
    },

    stocks(state) {
        return state.stockCheck.stocks;
    },

    hasCheckedStocks(state) {
        return state.stockCheck.stocks.length > 0;
    },

    outlet(state) {
        return state.stockCheck.outlet;
    },

    completionStatus(state, getters) {
        const check = state.stockCheck;

        if (check.status == COMPLETED) {
            return 'Completed';
        }

        return 'In Progress';
    },

    findStockIndex: (state, getters) => stock_id => {
        return getters.stocks.findIndex(s => s.stock_id == stock_id);
    },

    varianceTypes() {
        return varianceTypes;
    },
};

const mutations = {
    [types.SET_STOCK_CHECK](state, stockCheck) {
        state.stockCheck = stockCheck;
    },

    [types.ADD_COUNTED_STOCK](state, counted_stock) {
        state.stockCheck.stocks.push(counted_stock);
    },

    [types.REMOVE_COUNTED_STOCK](state, stockIndex) {
        state.stockCheck.stocks.splice(stockIndex, 1);
    },

    [types.UPDATE_COUNTED_STOCK](state, { stockIndex, attr, value }) {
        state.stockCheck.stocks[stockIndex][attr] = value;
    },

    [types.SAVE_STOCK_VARIANCE](state, variance) {
        const checkedStock = state.stockCheck.stocks.find(
            s => s.stock_id == variance.stock_id,
        );

        if (!_.isUndefined(checkedStock)) {
            checkedStock.variance.push(variance);
        }
    },

    [types.REMOVE_STOCK_VARIANCE](state, { stock_id, variance }) {
        const checkedStock = state.stockCheck.stocks.find(
            s => s.stock_id == stock_id,
        );

        if (!_.isUndefined(checkedStock)) {
            const removeIndex = checkedStock.variance.findIndex(
                v => v.type == variance.type,
            );

            checkedStock.variance.splice(removeIndex, 1);
        }
    },
};

const actions = {
    async getStockCheck({ commit, dispatch }, id) {
        startLoading(dispatch, 'fetch-stock-check');
        const url = Laroute.route('stock_checks.show', { id });

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'fetch-stock-check');
            commit(types.SET_STOCK_CHECK, data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-stock-check');
            throw e;
        }
    },

    removeCountedStock({ commit, getters }, stock_id) {
        const stockIndex = getters.findStockIndex(stock_id);

        if (stockIndex >= 0) {
            commit(types.REMOVE_COUNTED_STOCK, stockIndex);
        }
    },

    addCountedStock(
        { commit },
        { stockInventory, counted_quantity = null, difference = null } = {},
    ) {
        const counted_stock = {
            stock_id: stockInventory.stock_id,
            stock: stockInventory,
            variance: [],
            expected_quantity: stockInventory.quantity,
            counted_quantity,
            difference,
        };

        commit(types.ADD_COUNTED_STOCK, counted_stock);
    },

    updateCountedStock({ commit, getters }, { stock_id, attr, value }) {
        const stockIndex = getters.findStockIndex(stock_id);
        commit(types.UPDATE_COUNTED_STOCK, { stockIndex, attr, value });
    },

    saveStockVariance({ commit, state }, variance) {
        commit(types.SAVE_STOCK_VARIANCE, variance);
    },

    removeStockVariance({ commit, state }, payload) {
        commit(types.REMOVE_STOCK_VARIANCE, payload);
    },

    async updateStockCheck({ commit, state, dispatch }, finalized = false) {
        const stockCheck = state.stockCheck;
        let url, method, loader;

        loader = finalized ? 'complete-stock-check' : 'save-stock-check';

        if (finalized) {
            url = Laroute.route('stock_checks.finalize', { id: stockCheck.id });
            method = 'patch';
        } else {
            url = Laroute.route('stock_checks.update', { id: stockCheck.id });
            method = 'put';
        }

        startLoading(dispatch, loader);

        try {
            const { data } = await axios[method](url, stockCheck);
            endLoading(dispatch, loader);
            commit(types.SET_STOCK_CHECK, data);

            return data;
        } catch (e) {
            endLoading(dispatch, loader);
            throw e;
        }
    },

    async createStockCheck(context, stockCheck) {
        const url = Laroute.route('stock_checks.store');

        try {
            const { data } = await axios.post(url, stockCheck);
            return data;
        } catch (e) {
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/stock-check.js